export const name = 'siteEditorContextService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-editor-context' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
